import React from 'react'
import styled, { css } from 'styled-components'

const Wrapper = styled.label<{ variant: 'primary' | 'secondary' }>`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 6px;
  border: 1px solid;
  font-size: 14px;
  text-align: center;
  > input {
    opacity: 0;
    position: absolute;
    left: -9999em;
  }
  :focus-within {
    outline: 2px solid;
    outline-offset: 2px;
  }
  ${({ variant, theme }) =>
    variant === 'secondary'
      ? css`
          color: ${theme.toggleButton.secondary.colour};
          border-color: ${theme.toggleButton.secondary.borderColor};
          background-color: ${theme.toggleButton.secondary.backgroundColour};
          :active,
          :has(input:active) {
            border-color: ${theme.toggleButton.secondary.activeBorderColour};
            background-color: ${theme.toggleButton.secondary
              .activeBackgroundColour};
            color: ${theme.toggleButton.secondary.activeColour};
          }
          :hover,
          :focus-within {
            color: ${theme.toggleButton.secondary.hoverFocusColour};
            border-color: ${theme.toggleButton.secondary
              .hoverFocusBorderColour};

            outline-color: ${theme.toggleButton.secondary
              .hoverFocusBorderColour};
            background-color: ${theme.toggleButton.secondary
              .hoverFocusBackgroundColour};
          }
          :has(input:checked) {
            color: ${theme.toggleButton.secondary.checkedColour};
            border-color: ${theme.toggleButton.secondary.checkedBorderColour};
            background-color: ${theme.toggleButton.secondary
              .checkedBackgroundColour};
          }
        `
      : css`
          color: ${theme.toggleButton.primary.colour};
          border-color: ${theme.toggleButton.primary.borderColor};
          background-color: ${theme.toggleButton.primary.backgroundColour};
          :active,
          :has(input:active) {
            border-color: ${theme.toggleButton.primary.activeBorderColour};
            background-color: ${theme.toggleButton.primary
              .activeBackgroundColour};
            color: ${theme.toggleButton.primary.activeColour};
          }
          :hover,
          :focus-within {
            color: ${theme.toggleButton.primary.hoverFocusColour};
            border-color: ${theme.toggleButton.primary.hoverFocusBorderColour};
            background-color: ${theme.toggleButton.primary
              .hoverFocusBackgroundColour};
          }
          :has(input:checked) {
            color: ${theme.toggleButton.primary.checkedColour};
            border-color: ${theme.toggleButton.primary.checkedBorderColour};
            background-color: ${theme.toggleButton.primary
              .checkedBackgroundColour};
          }
        `}
`

export function NumericToggleButton({
  children,
  variant = 'primary',
  type = 'checkbox',
  ...rest
}: {
  variant?: 'primary' | 'secondary'
  type?: 'checkbox' | 'radio'
  children: number
} & Omit<
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >,
  'type'
>) {
  return (
    <Wrapper variant={variant}>
      <input {...rest} type={type} />
      <span>{children}</span>
    </Wrapper>
  )
}
